import { render } from "./CommandStatisticsTable.vue?vue&type=template&id=08a585db"
import script from "./CommandStatisticsTable.vue?vue&type=script&lang=js"
export * from "./CommandStatisticsTable.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__